import { CurrencyFormat } from "../../../utils";
import usePaymentOptions from "../../hooks/usePaymentOptions";

/**
 * Componente de precio y bonificaciones para la versión seleccionada (v2)
 * Muestra el precio más bajo posible (con todos los bonos disponibles)
 * Este precio NO es dinámico - siempre muestra el mejor precio asumiendo todos los bonos
 */
const VersionPriceAndBonus = ({ model, version }) => {
    const { isMAF, isKinto, isCash } = usePaymentOptions();
    
    let price = version.price;
    let greenTax = version.green_tax;
    
    // Verificar si tiene bonificaciones disponibles (mostrar todos los bonos que existan)
    // Este componente muestra el precio "más bajo" asumiendo TODOS los bonos disponibles
    const hasBonus = 
        version.brand_bonus || 
        version.financing_bonus || 
        version.smart_buy_bonus;

    return (
        <div className="details">
            <h1>
                {model.name} {version.name}
            </h1>
            <div className="version-price">
                <p>
                    {CurrencyFormat(price)} <sup>(&lowast;)</sup>
                    <span>
                        <small>+I.V. {CurrencyFormat(greenTax)}</small>
                    </span>
                </p>
                <small>* Precio aplica para Régimen General y no para zona Franca</small>
            </div>
            {version.iva_warning ? <p className="version_warning">Precio incluye IVA</p> : null}
            {version.stock_warning ? (
                <p className="version_warning">Consultar disponibilidad</p>
            ) : null}
            {hasBonus && (
                <div className="bonus-container">
                    <div className="bonus-title">
                        <img
                            src={`${window._env_.STATIC_HOST}/static/website/images/icons/bonus-new.svg`}
                        />
                        <p>El precio reflejado incluye:</p>
                    </div>
                    <ul>
                        {version.brand_bonus && (
                            <li>
                                Bono <strong>marca</strong> de {CurrencyFormat(version.brand_bonus)}
                                .
                            </li>
                        )}
                        {version.financing_bonus && (
                            <li>
                                Bono <strong>financiamiento MAF</strong> de{" "}
                                {CurrencyFormat(version.financing_bonus)}.
                            </li>
                        )}
                        {version.smart_buy_bonus && (
                            <li>
                                Bono <strong>financiamiento Plan Renueve</strong> de{" "}
                                {CurrencyFormat(version.smart_buy_bonus)}.
                            </li>
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default VersionPriceAndBonus;
